import { TFPageContent, TFPageHeader } from '@tf/shared';
import { Icon } from '@tf/ui';
import { T } from '@tf/utils';
import { Navigate, useParams } from 'react-router-dom';
import { ProfilesTable } from '@/components/profiles/ProfilesTable';
import { AddProfileButton } from '@/components/shared';
import { type ProfileGroups, useProfileGroupsSchemas } from '@/core/api/profiles';
import { appStore } from '@/core/stores';

export const ProfileGroupsRoute = () => {
	const { groupLabel } = useParams<{ groupLabel: string }>();
	const { data: profileGroups, isLoading } = useProfileGroupsSchemas();
	const tenant = appStore.tenant?.get();

	T.assertNotNullish(tenant, 'no tenant in appStore');
	T.assertNotNullish(groupLabel, 'groupLabel param is required');

	if (isLoading) {
		return null;
	}

	const groupConfig = profileGroups?.groups?.find(
		(group: ProfileGroups) => group.label.toLowerCase() === groupLabel?.toLowerCase(),
	);

	const isFirstGroup =
		profileGroups?.groups && profileGroups.groups[0]?.label.toLowerCase() === groupLabel?.toLowerCase();

	if (!groupConfig || isFirstGroup) {
		return <Navigate to="/" replace />;
	}

	return (
		<>
			<TFPageHeader tenant={tenant} title={groupConfig.label} toolbar={<AddProfileButton />} />
			<TFPageContent>
				<ProfilesTable
					filterByKinds={groupConfig.kinds}
					storageKeyPrefix={groupConfig.label.toLowerCase()}
					emptyStateIcon={<Icon.IconUsers />}
					emptyStateTitle={`No ${groupConfig.label.toLowerCase()} found`}
					searchPlaceholder={`Search by ${groupConfig.label.toLowerCase()} name`}
					columnLabels={{
						name: 'Name',
						type: 'Type',
						status: 'Status',
					}}
				/>
			</TFPageContent>
		</>
	);
};
